export enum Experience {
    ADVANCED = "Advanced",
    NATIVE = "Native",
    BASIC = "Basic",
    LEARNING = "Learning"
}